import { AddCommentOutlined } from "@mui/icons-material";
import { Badge, IconButton } from "@mui/material";
import { isFunction, size } from "lodash";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useCommentUtilsHook } from "../../../hooks/utils/useCommentUtilsHook";

const BorrowerAssociatedCommentsBadge = ({ borrowerId, borrower, onClick }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { getCommentsAssociatedWithBorrower } = useCommentUtilsHook();

  const associatedComments = useMemo(() => {
    const targetId = borrowerId || borrower?._id;
    return getCommentsAssociatedWithBorrower(loanDrilldown?.comments, targetId);
  }, [
    getCommentsAssociatedWithBorrower,
    loanDrilldown?.comments,
    borrowerId,
    borrower?._id,
  ]);

  const handleOnClick = useCallback(() => {
    if (isFunction(onClick)) {
      onClick(associatedComments);
    }
  }, [associatedComments, onClick]);

  const styles = useMemo(() => {
    return {
      ".MuiBadge-badge": {
        minWidth: "16px",
        height: "16px",
        fontSize: "10px",
        transform: "scale(1) translate(50%, -60%)",
      },
    };
  }, []);

  if (size(associatedComments) === 0) {
    return null;
  }

  return (
    <IconButton size="small" onClick={handleOnClick} sx={styles}>
      <Badge badgeContent={size(associatedComments)} color="primary">
        <AddCommentOutlined className="thin" />
      </Badge>
    </IconButton>
  );

  if (isFunction(onClick)) {
    return (
      <IconButton size="small" onClick={handleOnClick} sx={styles}>
        <Badge badgeContent={size(associatedComments)} color="primary">
          <AddCommentOutlined className="thin" />
        </Badge>
      </IconButton>
    );
  }
  return (
    <>
      <Badge
        badgeContent={size(associatedComments)}
        color="primary"
        sx={styles}
      >
        <AddCommentOutlined size="small" className="thin" />
      </Badge>
    </>
  );
};
export default BorrowerAssociatedCommentsBadge;
